import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { delay, finalize, map, switchMap, tap } from 'rxjs/operators';
import { LegalizationService } from 'src/app/data/legalization.service';
import { Filter } from 'src/app/models/common/filter';
import { LegalizationDocumentSummaryDto } from '../../models/dtos/legalization-document-summary-dto';

interface PagingRequest {
  Page: number;
  PageSize: number;
  SortingDirection: string;
  SortingField: string;
  Filters: Filter[];
  IncludeInactive?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LegalizationAllDocumentsListDataSource {
  private legalizationService = inject(LegalizationService);

  countSubject = new BehaviorSubject<number>(0);
  count$: Observable<number> = this.countSubject.asObservable();

  loading$ = new BehaviorSubject<boolean>(false);
  legalizationsSubject = new Subject<PagingRequest>();

  documents$: Observable<LegalizationDocumentSummaryDto[]> = this.legalizationsSubject.pipe(
    delay(0),
    switchMap((request) => {
      this.loading$.next(true);
      return this.legalizationService.getAllLegalizationDocuments(
        request.Page,
        request.PageSize,
        request.SortingField,
        request.SortingDirection,
        request.Filters,
        request.IncludeInactive
      ).pipe(
        tap((res) => this.countSubject.next(res.Count)),
        map((res) => res.Results),
        finalize(() => this.loading$.next(false))
      );
    }),
  );

  constructor() { }
}